var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLifeBuoy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A4FAFD1C-E6F6-4303-898F-8E6865F68835@1,5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.25,0 C12.8063492,0 16.5,3.69365081 16.5,8.25 C16.5,12.8063492 12.8063492,16.5 8.25,16.5 C3.69365081,16.5 0,12.8063492 0,8.25 C0,3.69365081 3.69365081,0 8.25,0 Z M8.25,12 C7.48579537,12 6.77498162,11.7714065 6.18220685,11.3788677 L4.03661674,13.5238294 C5.19138822,14.4476074 6.65618501,15 8.25,15 C9.84381499,15 11.3086118,14.4476074 12.4633833,13.5238294 L10.3177932,11.3788677 C9.72501838,11.7714065 9.01420463,12 8.25,12 Z M13.5246406,4.03763096 L12.192,5.367 L11.3788677,6.18220685 C11.7714065,6.77498162 12,7.48579537 12,8.25 C12,9.01420463 11.7714065,9.72501838 11.3788677,10.3177932 L13.5238294,12.4633833 C14.4476074,11.3086118 15,9.84381499 15,8.25 C15,6.65665158 14.4479308,5.19224584 13.5246406,4.03763096 Z M1.5,8.25 C1.5,9.84381499 2.05239257,11.3086118 2.97617059,12.4633833 L5.12113232,10.3177932 C4.72859348,9.72501838 4.5,9.01420463 4.5,8.25 C4.5,7.48579537 4.72859348,6.77498162 5.12113232,6.18220685 L2.97617059,4.03661674 C2.05239257,5.19138822 1.5,6.65618501 1.5,8.25 Z M8.25,6 C7.00735931,6 6,7.00735931 6,8.25 C6,9.49264069 7.00735931,10.5 8.25,10.5 C9.49264069,10.5 10.5,9.49264069 10.5,8.25 C10.5,7.00735931 9.49264069,6 8.25,6 Z M8.25,1.5 C6.65618501,1.5 5.19138822,2.05239257 4.03661674,2.97617059 L6.18220685,5.12113232 C6.77498162,4.72859348 7.48579537,4.5 8.25,4.5 C9.01420463,4.5 9.72501838,4.72859348 10.3177932,5.12113232 L12.462369,2.9753594 C11.3077542,2.0520692 9.84334842,1.5 8.25,1.5 Z",
    id: "path-1-life-buoy"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Inexplor\\xE9",
    stroke: "none",
    strokeWidth: 1,
    fill: "current",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01_interactions",
    transform: "translate(-171.000000, -647.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(139.000000, 553.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(12.757058, 36.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(19.242942, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/user-Copy-5",
    transform: "translate(0.750000, 58.750000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "FFF"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1-life-buoy"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "FFF",
    xlinkHref: "#path-1-life-buoy"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeBuoy);
export default __webpack_public_path__ + "static/media/life_buoy.33004e44e3dd9d97109b34fd8a8c2a4e.svg";
export { ForwardRef as ReactComponent };